import axios from "axios";

const apiBaseUrl = 'https://api-test.texelio.com/api'

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const getAccessToken = async () => {
  await delay(100);
  //return "eyJhbG...."
  throw Error(
    'To Run this demo change implementation of function getAccessToken (src/common/api.js) to return a valid Texelio API access token '+
    'with scope: podcast.read. \n\n Warning: do not expose authentication credentials used to acquire accessToken in frontend code (!).')
}

export const getPodCastsFromApi = async ({
  abortControllerRef
}) => {
  abortControllerRef.current = new AbortController();
  const results = await axios({
    method: "get",
    url: `${apiBaseUrl}/podcasts`,
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + (await getAccessToken())
    },
    signal: abortControllerRef.current.signal,
  });
  return results;
};

export const getPodCastEpisodeFromApi = async ({
  abortControllerRef,
  podcastId,
}) => {
  abortControllerRef.current = new AbortController();
  const results = await axios({
    method: "get",
    url: `${apiBaseUrl}/podcasts/episode/${podcastId}`,
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + (await getAccessToken())
    },
    signal: abortControllerRef.current.signal,
  });
  return results;

};

export const getTranscriptDataFromUrl = async ({
  transcriptUrl,
  abortControllerRef
}) => {
  abortControllerRef.current = new AbortController();
  const results = await axios({
    method: "get",
    url: transcriptUrl,
    signal: abortControllerRef.current.signal,
  });
  return results;
}